import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../redux-store";

const selectRoot = (state: RootState) => state.data.mailOrders;

export const selectMailOrderSettings = createSelector(
  selectRoot,
  (s) => s.settings
);

export const selectMailOrderSettingsStatus = createSelector(
  selectRoot,
  (s) => s.settingsStatus
);

const selectMailSourceState = (cargoId: string) =>
  createSelector(selectRoot, (s) => s.source[cargoId]);

/** The source mail, or null when the cargo wasn't created from one. */
export const selectMailSource = (cargoId: string) =>
  createSelector(selectMailSourceState(cargoId), (s) =>
    s?.status === "loaded" ? s.mail : null
  );

/** True only for a real failure - a 404 ("no source mail") is not one. */
export const selectMailSourceFailed = (cargoId: string) =>
  createSelector(selectMailSourceState(cargoId), (s) => s?.status === "error");

export const selectMailOrderTemplateSaveState = (cargoId: string) =>
  createSelector(selectRoot, (s) => s.templateSave[cargoId]);

export const selectMailOrderTemplates = createSelector(
  selectRoot,
  (s) => s.templates
);

export const selectMailOrderTemplatesStatus = createSelector(
  selectRoot,
  (s) => s.templatesStatus
);

export const selectMailOrderTemplateDetail = createSelector(
  selectRoot,
  (s) => s.templateDetail
);

export const selectMailOrderTemplateDetailStatus = createSelector(
  selectRoot,
  (s) => s.templateDetailStatus
);

export const selectSavingMailOrderTemplate = createSelector(
  selectRoot,
  (s) => s.savingTemplateDetail
);
